import { Core, Feature, ProfileTypes } from "..";

export interface Header {
    networkId: string;
    id: string;
    name: string;

    shown: boolean;
    isTestPartner: boolean;
    isPendingApproval: boolean;
}

export interface Profile {
    address: ProfileTypes.Address;
}

export interface Partner extends Header {
    profile: Profile;
    attachments: {[key in AttachmentType]: Core.Document};
    preferences: Preferences;
    adminSettings: AdminSettings;
    pairingCode: string;
}

export enum AttachmentType {
    LOGO="LOGO",
    DIRECTOR_AUTH_LETTER="DIRECTOR_AUTH_LETTER",
    CASEWORKER_AUTH_LETTER="CASEWORKER_AUTH_LETTER",
}

export interface Preferences {
    notifications: {
        notaryEmails: string[];
    };
}

export interface AdminSettings {
    enabledModules: Record<string, Feature.Status>;
    networkProcessesBirthCertificateApplications: boolean;
}
